import { Link } from 'react-router-dom';

export const focusRing = 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#f2c66d]';

export const pillClass = `grid h-11 place-items-center rounded-full border border-white/12 bg-white/5 px-4 text-sm hover:bg-white/10 ${focusRing}`;

export function SiteHeader({ action }: { action: { to: string; label: string } }) {
  return (
    <header className="flex items-center justify-between px-5 py-3">
      <Link to="/" className={`group ${focusRing}`}>
        <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-[#f2c66d]/85">Memory Globe</p>
        <p className="text-sm text-white/50 group-hover:text-white/70">places, in three dimensions</p>
      </Link>
      <Link to={action.to} className={pillClass}>
        {action.label}
      </Link>
    </header>
  );
}
